enum ActionType {
  CLEAR_ERRORS = 'CLEAR_ERRORS'
}

export default ActionType;
